


































import { Component, Vue, Prop } from "vue-property-decorator";
import { IInvoice } from "@/models/invoices";
import InvoiceCreditRefundForm from "@/components/app/global/invoices/invoiceCreditRefundForm.vue";
@Component({
  components: {
    InvoiceCreditRefundForm,
    "invoice-credit-refund-provider": () =>
      import("@/components/app/global/invoices/invoiceCreditRefundProvider.vue")
  }
})
export default class InvoiceCreditRefundModal extends Vue {
  // Props
  @Prop({ required: true })
  public invoice!: IInvoice;

  public isSubmitDisabled = true;
  public isProcessing = false;

  public get title() {
    return `${this.$t("_.invoice_#", {
      invoiceNum: this.$_.get(this.invoice, "number")
    })}: ${this.$t("_.credit_refund_options")}`;
  }

  public validateBeforeSubmit() {
    (this.$refs
      ?.invoiceCreditRefundForm as InvoiceCreditRefundForm)?.validateBeforeSubmit();
  }
}
